(function ($) {
	'use strict';

	$(function () {
		const $trigger = $('.js-expand-filters-trigger');
		const activeClass = 'is-active';

		$trigger.on('click', function () {
			const $body = $(this).next('.js-expand-filters-body');

			$(this).toggleClass(activeClass);
			$body.slideToggle();
		});
	});
})(jQuery);
